export class FabJob {
    id!: string
    indexId!: number
    vpJobId?: string | null
    scheduleReference?: string | null
    name?: string | null
    isInternal!: boolean
    active!: boolean
    modifiedDate?: Date | string
    modifiedByUserId?: string
    jobDescription?: string
    displayName!: string
}

export class FabUnresolvedJob {
    id!: string
    scheduleReference?: string | null
    name?: string | null
    vpJobId?: string | null
    isInternal!: boolean
    pieceCount!: number
    sampleMarks?: string
    reason!: string
}
